import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddProperty from './AddProperty';
import { showProperty } from 'actions/landlordPropertiesActions';

export default connect(null, { showProperty })(
  class PropertyDetails extends Component {
    componentWillUnmount = () => {
      // clear property
      this.props.showProperty();
    };

    render() {
      return <AddProperty isModeEdit={true} />;
    }
  }
);
